// extracted by mini-css-extract-plugin
export default {"container":"fixedPortal_container__KX1H6"};